<template>
    <div v-if="user">

        <va-page-header>

            <div slot="title">
                <span :key="catKey" v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager')"
                    :class="{edit_title: true, edit_title_cat: true}" @click="showCategoryModal">
                    {{ g_getLabel(getCategory) }}
                    <va-icon style="zoom: 0.9; margin-left: 10px" color="#999" type="pencil-alt">
                    </va-icon>
                </span>
                <span :key="catKey"
                    v-else>{{ user && user.get('roles').includes('guest') ? 'Your'  :  g_getLabel(getCategory)}}</span>
            </div>

            <div slot="actions">
                <va-button
                    v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor') || user.get('roles').includes(section + '-creator')"
                    @click.native="$router.push('/' + section + 's/' + $route.params.scope + '/' + $route.params.category + '/edit/new')"
                    style="position: absolute; right: 22px; top: 20px;" type="primary" size="lg">
                    {{ _('NEW ' + section.toUpperCase()) }}</va-button>
            </div>

        </va-page-header>

        <category :key="category_key" v-if="makeCategoryModalVisible" :class="{click: disableScreen}"
            v-on:hide-modal="hideCategoryModal" v-on:disable-screen="setDisableScreenValue"
            :title="sectionCapitalized + ' Category'" :department="categoryDepartment"
            :category_for_update="getCategory" :can_delete="true" />

        <data-list :key="" :isSubmissions="false" />

    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import DataList from "./DataList.vue"
    import Category from "./Category.vue"

    export default {
        name: 'section-objects-wrapper',
        components: {
            DataList,
            Category
        },

        data() {
            return {
                catKey: '',
                section: '',
                sectionCapitalized: '',
                makeCategoryModalVisible: false,
                disableScreen: false,
                categoryDepartment: null,
                currentDepartment: null,
                category: null,
                category_key: '',
            };
        },

        watch: {
            async '$route'(to, from) {
                this.fetchings()
            },
        },


        computed: {
            ...mapGetters(['user', 'getCurrentCategory', 'getCurrentDepartment']),

            getCategory() {
                return this.category || this.getCurrentCategory
            },

        },

        methods: {
            hideCategoryModal() {
                this.makeCategoryModalVisible = false
            },

            setDisableScreenValue(val) {
                this.disableScreen = val
            },

            showCategoryModal() {
                this.makeCategoryModalVisible = true
                this.categoryDepartment = this.getCategory.get('department')
            },

            fetchings() {
                this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
                this.sectionCapitalized = this.section.charAt(0).toUpperCase() + this.section.slice(1)
                this.category = this.getCurrentCategory
                this.currentDepartment = this.getCurrentDepartment
                this.category_key = Date.now().toString()
            }

        },
        mounted() {
            this.fetchings()
        }
    };
</script>

<style>
    .fixed_td .va-table .td {
        max-width: 100px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }
</style>